<template>
  <a-modal v-model="visible" title="第二步：选择应用课程" @ok="handleOk" @cancel="closeModal(true)" width="1200px">
    <div>请选择要将新规则应用到哪些课程：</div>
    <selectExpCourse ref="selectExpCourseRef" @changeCount="changeCount" :columns="columns" />
    <div class="body-bottom" v-if="count">将规则应用到{{ count }}门课程</div>
    <a-row slot="footer">
      <a-button @click="prevStep">上一步</a-button>
      <a-button type="primary" @click="handleOk">确认添加</a-button>
    </a-row>
  </a-modal>
</template>

<script>
import selectExpCourse from './selectExpCourse.vue'

const columns = [
  {
    title: '关联课程',
    dataIndex: 'name',
  },
  {
    title: '学段',
    dataIndex: 'period',
  },
  {
    title: '课时数',
    dataIndex: 'courseSessionCount',
  },
]
export default {
  name: 'SelectExpCourse',
  components: { selectExpCourse },
  data() {
    return {
      visible: false,
      columns: columns,
      count: 0,
      subTitle: '请选择要将体验游戏应用到哪些课程（不同学段适合不同的游戏）；',
    }
  },
  methods: {
    changeCount(count) {
      this.count = count
    },
    showModal(options = {}) {
      return new Promise((resolve, reject) => {
        this._resolve = resolve
        this._reject = reject
        this.visible = true
        if (options.subTitle) {
          this.subTitle = options.subTitle
        }
        this.$nextTick(() => {
          this.$refs['selectExpCourseRef'].getPageList(true)
        })
      })
    },
    closeModal(isReject, params) {
      this.visible = false
      isReject ? this._reject(params) : this._resolve(params)
    },
    prevStep() {
      this.closeModal(false, { type: 'prev' })
    },
    handleOk() {
      const selectExpCourseRef = this.$refs['selectExpCourseRef']
      const selectkeys = selectExpCourseRef.selectedRowKeys
      const selectRows = selectExpCourseRef.selectedRows
      if (!selectkeys.length) {
        return this.$message.error('请选择课程')
      }
      this.closeModal(false, { keys: [...selectkeys], rows: [...selectRows], type: 'ok' })
    },
  },
}
</script>
<style>
.body-bottom {
  margin-top: 16px;
}
</style>
